export const MessageListScrollNotifyBusKey = "message-list-scroll-notify";

export type MessageListScrollNotifyBus = {
  scrollOnlyIfAlreadyInBottom: boolean;
};
